import axios from 'axios';
import Cookies from 'js-cookie';

const invalidateCSRF = async function (){
  if(process.env.REACT_APP_ENV=='development'){
    document.cookie = `_otp__csrf=; Max-Age=-99999999;path=/;domain=127.0.0.1;`;
    document.cookie = `_otp__csrf_token=; Max-Age=-99999999;path=/;domain=127.0.0.1;`;
  }else{
    document.cookie = `_otp__csrf=; Max-Age=-99999999;path=/;domain=.jubelio.com;`;
    document.cookie = `_otp__csrf_token=; Max-Age=-99999999;path=/;domain=.jubelio.com;`;
  }
}

const setCSRF = async function (){

  try {
      const fetch = await axios.get('https://account-service.qm-staging-k8s.jubelio.io/api/v1/csrf',
        // { withCredentials: true }
      );
      return fetch.data;
    } catch (error:any) {
      if(error.response.data!=undefined){
        return error.response.data;
      }else{
        return {
          statusCode: 400,
          message: "error"
        };
      }
      
    }
}

const checkResendOTP = async function (){
  await setCSRF();
  try {
      const fetch = await axios.post('https://account-service.qm-staging-k8s.jubelio.io/api/v1/otp-sms/check-resend',{},{ 
        // withCredentials: true,
        headers: {
          'x-otp-csrf-secret': 'yg5K4krSHchv0Q09o67NF__8',
          'x-otp-csrf-token': 'eezrhKFR-iYw6QM5hUp9W1lAX_UIxD_kwo8g'
        }
      });
      return fetch.data;
    } catch (error:any) {
      if(error.response.data!=undefined){
        return error.response.data;
      }else{
        return {
          statusCode: 400,
          message: "error"
        };
      }
      
    }
}

const sendOTP = async function (phoneNumber?:string){
    await setCSRF();
    try {
        const fetch = await axios.post('https://account-service.qm-staging-k8s.jubelio.io/api/v1/otp-sms/send',{phoneNumber: phoneNumber},{ 
          // withCredentials: true,
          headers: {
            'x-otp-csrf-secret': 'yg5K4krSHchv0Q09o67NF__8',
            'x-otp-csrf-token': 'eezrhKFR-iYw6QM5hUp9W1lAX_UIxD_kwo8g'
          }
        });
        invalidateCSRF();
        return fetch.data;
      } catch (error:any) {
        if(error.response.data!=undefined){
          invalidateCSRF();
          return error.response.data;
        }else{
          invalidateCSRF();
          return {
            statusCode: 400,
            message: "error"
          };
        }
        
      }
}

const validateOTP = async function (otp:number){
  await setCSRF();
  try {
      const fetch = await axios.post('https://account-service.qm-staging-k8s.jubelio.io/api/v1/otp-sms/validate',{otp: otp},{ 
        // withCredentials: true,
        headers: {
          'x-otp-csrf-secret': 'yg5K4krSHchv0Q09o67NF__8',
          'x-otp-csrf-token': 'eezrhKFR-iYw6QM5hUp9W1lAX_UIxD_kwo8g'
        }
      });
      return fetch.data;
    } catch (error:any) {
      if(error.response.data!=undefined){
        return error.response.data;
      }else{
        return {
          statusCode: 400,
          message: "error"
        };
      }
    }
}

export default {
    sendOTP: sendOTP,
    checkResendOTP: checkResendOTP,
    validateOTP: validateOTP,
    setCSRF: setCSRF
}
  

